/**
 * 门户表格默认配置数据
 */
export const home = [
  {
    width:800,
    height:300,
    isShowSerialNumber: false, // 是否显示序号,
    defaultFontColor: "#253650",
    headerFontColor: "#253650",
    headerHeight: 50,
    rowsHeight:50,
    headerData : ["姓名","学号", "班级", "成绩"],
    headerFontSize:14,
    defaultFontSize:14,
    headerFontWeight:600,
    headerBgColor:"#e7f4fa",
    oddBgColor:"rgba(255, 255, 255, 1)",
    evenBgColor:"#F8FCFE",
    listData : [
      ["张萌萌","00001","3年级1班", "99"],
      ["王明玉","00002","3年级1班",  "98"],
      ["王建国", "00003","3年级1班", "92"],
      ["欧菲菲", "00004","3年级1班", "90"],
      ["郭山闪", "00005", "3年级1班", "85"],
    ]
  },
  // {
  //   headerHeight: 50,
  //   rowsHeight:50,
  //   serialNumberHeaderData: [
  //     {
  //       value: "姓名", // 列名
  //       align: "center", // 内容对齐方式 "left/center/right"
  //       type: "text", // 字段显示方式 "text/image"
  //       isDesensitization: false, // 是否脱敏
  //       width: 200,
  //       height: 20,
  //       borderRadius: 6,
  //       fontSize: 16,
  //       fontFamily: "sans-serif",
  //       fontWeight: "400",
  //       fontColor: "rgba(0, 0, 0, 0.8)"
  //     },
  //     {
  //       value: "学号", // 列名
  //       align: "center", // 内容对齐方式 "left/center/right"
  //       type: "text", // 字段显示方式 "text/image"
  //       isDesensitization: false, // 是否脱敏
  //       width: 20,
  //       height: 20,
  //       borderRadius: 6,
  //       fontSize: 16,
  //       fontFamily: "sans-serif",
  //       fontWeight: "400",
  //       fontColor: "rgba(0, 0, 0, 0.8)"
  //     },
  //     {
  //       value: "成绩", // 列名
  //       align: "center", // 内容对齐方式 "left/center/right"
  //       type: "text", // 字段显示方式 "text/image"
  //       isDesensitization: false, // 是否脱敏
  //       width: 20,
  //       height: 20,
  //       borderRadius: 6,
  //       fontSize: 16,
  //       fontFamily: "sans-serif",
  //       fontWeight: "400",
  //       fontColor: "rgba(0, 0, 0, 0.8)"
  //     }
  //   ],
  //   isShowSerialNumber: true,
  //   isShowRank: true,// 是否显示排序表格的排序
  //   serialNumberShowRankText: true,
  //   serialNumberRankTextFontFamily: "sans-serif",
  //   serialNumberRankTextFontSize: 12,
  //   serialNumberRankTextFontWeight: "400",
  //   serialNumberRankTextFontColor: "rgba(255, 255, 255, 0.8)",
  //   serialNumberShowSerialNumberBg: true,
  //   serialNumberBgType: "round", // roundedRectangle：圆角矩形、round：圆形、diamond：菱形、image：图片
  //   serialNumberBgW: 20,
  //   serialNumberBgH: 20,
  //   serialNumberBgImg: "",
  //   serialNumberBgRadius: 6,
  //   serialNumberBgColor: "#00043A",
  //   // 特殊行配置
  //   serialNumberSpecialRows: [
  //     // {
  //     //   rowIndex: 1,
  //     //   specialBgColor: "rgba(0,4,58,1)",
  //     //   specialFontFamily: "sans-serif",
  //     //   specialFontSize: 12,
  //     //   specialFontWeight: 400,
  //     //   specialFontColor: "rgba(0, 0, 0, 0.8)"
  //     // },
  //     // {
  //     //   rowIndex: 2,
  //     //   specialBgColor: "rgba(0,4,58,1)",
  //     //   specialFontFamily: "sans-serif",
  //     //   specialFontSize: 12,
  //     //   specialFontWeight: 400,
  //     //   specialFontColor: "rgba(0, 0, 0, 0.8)"
  //     // }
  //   ],
  //   dynamicHeaderName: "动态数据", // 动态数据表头名称
  //   // 动态数据的条件
  //   dynamicData: [
  //     {
  //       type: "singleValue", // singleValue: 单值判断；range: 区间范围
  //       target: "", // 目标变量
  //       condition: "等于", // 条件  等于；不等于；包含；不包含；大于；小于
  //       conditionRange: [0, 10],
  //       parameter: "", // 参数值
  //       result: "", // 结果
  //       resultFontSize: 12,
  //       resultFontFamily: "sans-serif",
  //       resultFontWeight: "400",
  //       resultFontColor: "rgba(0, 0, 0, 0.8)"
  //     }
  //   ]
  // }
]

/**
 * 大屏表格默认配置数据
 */
export const bs = [
  {
    isShowSerialNumber: false // 是否显示序号
  },
  {
    styleId:2,
    serialNumberHeaderData: [
      {
        value: "学号", // 列名
        align: "center", // 内容对齐方式 "left/center/right"
        type: "text", // 字段显示方式 "text/image"
        isDesensitization: false, // 是否脱敏
        width: 20,
        height: 20,
        borderRadius: 6,
        fontSize: 16,
        fontFamily: "sans-serif",
        fontWeight: "400",
        fontColor: "rgba(255, 255, 255, 0.8)"
      },
      {
        value: "姓名", // 列名
        align: "center", // 内容对齐方式 "left/center/right"
        type: "text", // 字段显示方式 "text/image"
        isDesensitization: false, // 是否脱敏
        width: 20,
        height: 20,
        borderRadius: 6,
        fontSize: 16,
        fontFamily: "sans-serif",
        fontWeight: "400",
        fontColor: "rgba(255, 255, 255, 0.8)"
      },
      {
        value: "成绩", // 列名
        align: "center", // 内容对齐方式 "left/center/right"
        type: "text", // 字段显示方式 "text/image"
        isDesensitization: false, // 是否脱敏
        width: 20,
        height: 20,
        borderRadius: 6,
        fontSize: 16,
        fontFamily: "sans-serif",
        fontWeight: "400",
        fontColor: "rgba(255, 255, 255, 0.8)"
      }
    ],
    isShowSerialNumber: true,
    isShowRank: true,// 是否显示排序表格的排序
    serialNumberShowRankText: true,
    serialNumberRankTextFontFamily: "D-din",
    serialNumberRankTextFontSize: 18,
    serialNumberRankTextFontWeight: "700",
    serialNumberRankTextFontColor: "rgb(102, 255, 255)",
    serialNumberShowSerialNumberBg: true,
    serialNumberBgType: "image", // roundedRectangle：圆角矩形、round：圆形、diamond：菱形、image：图片
    serialNumberBgW: 30,
    serialNumberBgH: 30,
    serialNumberBgImg: "https://p.ananas.chaoxing.com/star3/origin/a39c218bdd572e7fa7c77b00d733a8df.png",
    serialNumberBgRadius: 6,
    serialNumberBgColor: "#00043A",
    // 特殊行配置
    serialNumberSpecialRows: [
      {
        rowIndex: 1,
        // specialBgColor: "rgba(0,4,58,1)",
        specialFontFamily: "D-din",
        specialFontSize: 18,
        specialFontWeight: 700,
        specialFontColor: "rgb(102, 255, 255)",
        specialBgImg: "https://p.ananas.chaoxing.com/star3/origin/f3e390dd9631d61612b981ff6244772c.png"
      },
      {
        rowIndex: 2,
        // specialBgColor: "rgba(0,4,58,1)",
        specialFontFamily: "D-din",
        specialFontSize: 18,
        specialFontWeight: 700,
        specialFontColor: "rgb(102, 255, 255)",
        specialBgImg: "https://p.ananas.chaoxing.com/star3/origin/f3e390dd9631d61612b981ff6244772c.png"
      }
    ],
    dynamicHeaderName: "评价", // 动态数据表头名称
    // 动态数据的条件
    dynamicData: [
      {
        type: "range", // singleValue: 单值判断；range: 区间范围
        target: "成绩", // 目标变量
        condition: "等于", // 条件  等于；不等于；包含；不包含；大于；小于
        conditionRange: [89, 100],
        parameter: "", // 参数值
        result: "优秀", // 结果
        resultFontSize: 16,
        resultFontFamily: "sans-serif",
        resultFontWeight: "400",
        resultFontColor: "rgb(255, 92, 90)"
      },{
        type: "range", // singleValue: 单值判断；range: 区间范围
        target: "成绩", // 目标变量
        condition: "等于", // 条件  等于；不等于；包含；不包含；大于；小于
        conditionRange: [79, 89],
        parameter: "", // 参数值
        result: "良好", // 结果
        resultFontSize: 16,
        resultFontFamily: "sans-serif",
        resultFontWeight: "400",
        resultFontColor: "rgb(255, 166, 63)"
      },
    ]
  }
]

/**
 * app表格默认配置数据
 */
export const appHome = [
  {
    width:420,
    isShowSerialNumber: false, // 是否显示序号,
    defaultFontColor: "rgba(0, 0, 0, 0.8)",
    headerHeight: 40,
    rowsHeight:50,
    headerData : ["排名","姓名", "班级", "成绩"],
    headerFontSize:12,
    defaultFontSize:12,
    listData : [
      ["1", "张萌萌","3年级1班", "99"],
      ["2", "王明玉","3年级1班",  "98"],
      ["3", "王建国", "3年级1班", "92"],
      ["4", "欧菲菲", "3年级1班", "90"],
      ["5", "郭山闪", "3年级1班", "85"],
      ["6", "邓华丽", "3年级1班", "85"]
    ]
  },
  // {
  //   styleId:2,
  //   headerHeight: 40,
  //   rowsHeight:50,
  //   serialNumberHeaderData: [
  //     {
  //       value: "学号", // 列名
  //       align: "center", // 内容对齐方式 "left/center/right"
  //       type: "text", // 字段显示方式 "text/image"
  //       isDesensitization: false, // 是否脱敏
  //       width: 20,
  //       height: 20,
  //       borderRadius: 6,
  //       fontSize: 16,
  //       fontFamily: "sans-serif",
  //       fontWeight: "400",
  //       fontColor: "rgba(0, 0, 0, 0.8)"
  //     },
  //     {
  //       value: "姓名", // 列名
  //       align: "center", // 内容对齐方式 "left/center/right"
  //       type: "text", // 字段显示方式 "text/image"
  //       isDesensitization: false, // 是否脱敏
  //       width: 20,
  //       height: 20,
  //       borderRadius: 6,
  //       fontSize: 16,
  //       fontFamily: "sans-serif",
  //       fontWeight: "400",
  //       fontColor: "rgba(0, 0, 0, 0.8)"
  //     },
  //     {
  //       value: "成绩", // 列名
  //       align: "center", // 内容对齐方式 "left/center/right"
  //       type: "text", // 字段显示方式 "text/image"
  //       isDesensitization: false, // 是否脱敏
  //       width: 20,
  //       height: 20,
  //       borderRadius: 6,
  //       fontSize: 16,
  //       fontFamily: "sans-serif",
  //       fontWeight: "400",
  //       fontColor: "rgba(0, 0, 0, 0.8)"
  //     }
  //   ],
  //   isShowSerialNumber: true,
  //   isShowRank: true,// 是否显示排序表格的排序
  //   serialNumberShowRankText: true,
  //   serialNumberRankTextFontFamily: "sans-serif",
  //   serialNumberRankTextFontSize: 12,
  //   serialNumberRankTextFontWeight: "400",
  //   serialNumberRankTextFontColor: "rgba(255, 255, 255, 0.8)",
  //   serialNumberShowSerialNumberBg: true,
  //   serialNumberBgType: "round", // roundedRectangle：圆角矩形、round：圆形、diamond：菱形、image：图片
  //   serialNumberBgW: 20,
  //   serialNumberBgH: 20,
  //   serialNumberBgImg: "",
  //   serialNumberBgRadius: 6,
  //   serialNumberBgColor: "#00043A",
  //   // 特殊行配置
  //   serialNumberSpecialRows: [
  //     // {
  //     //   rowIndex: 1,
  //     //   specialBgColor: "rgba(0,4,58,1)",
  //     //   specialFontFamily: "sans-serif",
  //     //   specialFontSize: 12,
  //     //   specialFontWeight: 400,
  //     //   specialFontColor: "rgba(0, 0, 0, 0.8)"
  //     // },
  //     // {
  //     //   rowIndex: 2,
  //     //   specialBgColor: "rgba(0,4,58,1)",
  //     //   specialFontFamily: "sans-serif",
  //     //   specialFontSize: 12,
  //     //   specialFontWeight: 400,
  //     //   specialFontColor: "rgba(0, 0, 0, 0.8)"
  //     // }
  //   ],
  //   dynamicHeaderName: "动态数据", // 动态数据表头名称
  //   // 动态数据的条件
  //   dynamicData: [
  //     {
  //       type: "singleValue", // singleValue: 单值判断；range: 区间范围
  //       target: "", // 目标变量
  //       condition: "等于", // 条件  等于；不等于；包含；不包含；大于；小于
  //       conditionRange: [0, 10],
  //       parameter: "", // 参数值
  //       result: "", // 结果
  //       resultFontSize: 12,
  //       resultFontFamily: "sans-serif",
  //       resultFontWeight: "400",
  //       resultFontColor: "rgba(0, 0, 0, 0.8)"
  //     }
  //   ]
  // }
]
